import { Box, Typography } from "@mui/material"
import { type FC } from "react"

import { CertificationStatus } from "../types"
import { CertificationStatusMap } from "../utils/certificationStatusMap"

import { StatusIndicator } from "@/components/common/StatusIndicator/StatusIndicator"

const CertificationLegend: FC = () => {
  return (
    <Box className='flex flex-wrap items-center gap-6 overflow-hidden'>
      <Typography variant='subtitle1' className='mr-2 text-gray-900'>
        Expires In:
      </Typography>

      {[
        [CertificationStatus.MORE_THAN, "More than 90 days"],
        [CertificationStatus.LESS_THAN, "Less than 90 days"],
        [CertificationStatus.EXPIRED, "Expired"],
      ].map(([status, label]) => (
        <Box key={status} className='flex items-center gap-3'>
          <StatusIndicator status={status} map={CertificationStatusMap} size='medium' />
          <Typography variant='body2'>{label}</Typography>
        </Box>
      ))}
    </Box>
  )
}

export default CertificationLegend
